import { Request } from '../../Servidor/Request';

export class PublicRideRequest {
    private sgeppasseiopublico: number;
    private nome: string;

	constructor(sgeppasseiopublico: number, nome: string) {
		this.sgeppasseiopublico = sgeppasseiopublico;
		this.nome = nome;
	}


    /**
     * Getter sgeppasseiopublico
     * @return {number}
     */
	public getSgeppasseiopublico(): number {
		return this.sgeppasseiopublico;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class PublicRideStructRequest {
    private sgeppasseiopublico: number;

	constructor(sgeppasseiopublico: number) {
        this.sgeppasseiopublico = sgeppasseiopublico;
	}


    /**
     * Getter sgeppasseiopublico
     * @return {number}
     */
	public getSgeppasseiopublico(): number {
		return this.sgeppasseiopublico;
	}

}

export class PublicRideStructResponse {
    private sgeppasseiopublico: number;
    private nome: string;

	constructor(sgeppasseiopublico: number, nome: string) {
		this.sgeppasseiopublico = sgeppasseiopublico;
		this.nome = nome;
	}


    /**
     * Getter sgeppasseiopublico
     * @return {number}
     */
	public getSgeppasseiopublico(): number {
		return this.sgeppasseiopublico;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class PublicRideInteractor {
    public fetchSave(request: PublicRideRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/passeio-publico/salvar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: PublicRideStructRequest): PromiseLike<PublicRideStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/passeio-publico/buscar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}